import React,{Component} from 'react';

import {
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';

import Button from '../../../shared/components/Button';
import Avatar from '../../../shared/components/Avatar';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';

import {
  alphabeticallySort,
  textContains
} from '../../../shared/utils';

class ManageSuperUsers extends Component {
  componentDidMount(){
    this.props.loadProviders();
  }

  render(){
    const { users, match, updateUser } = this.props;

    return (
      <Container>
        <Row className='EntityList-title'>
          <Col xs='6'>
            <h1>Manage Superusers</h1>
          </Col>
          <Col xs='6'>
            <Button
              className='pull-right'
              linkHref='/superadmin/superusers/new'
            >
              Invite
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <SearchableDataTable
              items={users}
              emptyText='Loading superusers...'
              searchPromptText='Search by name or email'
              isActiveFunc={(item) => item.active}
              columns={[
                {
                  width:10,
                  renderCell:(item) => (
                    <Avatar
                      userName={item.firstName}
                      imageUrl={item.avatarThumbnailURL}
                    />
                  )
                },{
                  width:40,
                  name:'firstName',
                  display:'Name',
                  filterFunc:(a,searchParam) => textContains(`${a.firstName} ${a.lastName}`,searchParam),
                  sortFunc:(a,b) => alphabeticallySort(a.firstName,b.firstName),
                  renderCell:(item) => (
                    <Link to={`${match.url}/${item.id}/edit`}>
                      {item.firstName || ''} {item.lastName || ''}
                    </Link>
                  )
                },{
                  width:25,
                  name:'email',
                  filterFunc:(a,searchParam) => textContains(a.email,searchParam),
                  sortFunc:(a,b) => alphabeticallySort(a.email,b.email),
                  renderCell:(item) => (
                    <a href={`mailto:${item.email}`}>
                      {item.email}
                    </a>
                  )
                },{
                  width:25,
                  renderCell:(item) => (
                    <div className='pull-right'>
                      <Button
                        size='sm'
                        linkHref={`${match.url}/${item.id}/edit`}
                        textColor='#666666'
                        borderColor='#cccccc'
                        backgroundColor='#fff'
                      >
                        Edit
                      </Button>
                      &nbsp;&nbsp;
                      <DropdownButton
                        options={[
                          {
                            text:item.active ? 'Deactivate' : 'Activate',
                            onClick:() => updateUser(item.id,{active:!item.active})
                          }
                        ]}
                      />
                    </div>
                  )
                }
              ]}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default ManageSuperUsers;



// WEBPACK FOOTER //
// ./src/routes/ManageSuperUsers/components/ManageSuperUsers.js